import { ToolbarProps } from "react-big-calendar";
import moment from "moment";

const CalendarHeaderDate = ({ toolbar }: { toolbar: ToolbarProps }) => {
  const { date } = toolbar;
  const nowDate = moment(date).format("MMM. YYYY");

  return <span className="text-80 font-medium w-[85px]">{nowDate}</span>;
};

export default CalendarHeaderDate;
